// Tiny synchronous key/value storage contract: { getItem, setItem, removeItem }.
// Synchronous on purpose, so the request interceptor can read the token
// without awaiting. On the phone, hydrate an in-memory copy from
// SecureStore/AsyncStorage before the first render and write through.

export const memoryStorage = (() => {
  const m = new Map();
  return {
    getItem: (k) => (m.has(k) ? m.get(k) : null),
    setItem: (k, v) => void m.set(k, String(v)),
    removeItem: (k) => void m.delete(k),
  };
})();

/** window.localStorage behind try/catch (private mode, blocked storage). */
export const webStorage = {
  getItem: (k) => {
    try { return window.localStorage.getItem(k); } catch { return null; }
  },
  setItem: (k, v) => {
    try { window.localStorage.setItem(k, v); } catch { /* ignore */ }
  },
  removeItem: (k) => {
    try { window.localStorage.removeItem(k); } catch { /* ignore */ }
  },
};
